<template>
  <j-modal
    :title="title"
    width="40%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <a-row :gutter="24">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="12" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <j-input :placeholder="$t('输入表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                </a-form-item>
              </a-col>
              <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <!-- <a-button type="primary" @click="addMeter" icon="plus" style="margin-left: 8px">添加表具</a-button> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          :columns="columns"
          :data-source="dataSource"
          rowKey="id"
          size="middle"
          :pagination="ipagination"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <a-button type="primary" @click="handleEdit(record)">{{ $t('选择') }}</a-button>
          </span>
        </a-table>
      </a-row>
    </a-spin>
    <MeterinfoModal ref="meterInfoForm" @ok="loadData"></MeterinfoModal>
  </j-modal>
</template>
          
<script>
import JInput from '@/components/jeecg/JInput'
import { getAction, postAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import MeterinfoModal from '@/views/meterManagement/modules/MeterinfoModal.vue'
export default {
  name: 'selectMeterIdModal',
  components: { MeterinfoModal,JInput },
  mixins: [JeecgListMixin],
  data() {
    return {
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      confirmLoading: false,
      validatorRules: {},
      url: {
        list: "/jeecg-charge/meter/meterinfo/list",
      },
      queryParam: {}
    }
  },
  computed: {
    // i18n：modal 标题
    title() {
      return this.$t('选择表具')
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align: 'center',
        },
        {
          title: this.$t('表类型'),
          dataIndex: 'mtName',
          align: 'center',
        },
        {
          title: this.$t('表口径'),
          dataIndex: 'mtCaliber',
          align: 'center',
          customRender: (t, r, index) => 'DN' + t,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]
    },
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
      this.loadData(1)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      this.close()
    },
    handleEdit(record){
        this.$emit('callback',record);
        this.close();
    },
    addMeter() {
      this.$nextTick(() => {
        this.$refs.meterInfoForm.add()
        this.$refs.meterInfoForm.title = this.$t('新增')
      })
    },
  },
}
</script>
        <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>